import React from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function DeceasedIndividualInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Deceased Individual Information</span>
        </div>
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.deceasedFirstName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.deceasedFirstName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.deceasedFirstName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.deceasedMiddleName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.deceasedMiddleName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.deceasedMiddleName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.deceasedLastName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.deceasedLastName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.deceasedLastName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.deceasedSuffixName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.deceasedSuffixName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.deceasedSuffixName]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.deceasedSSN)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.deceasedSSN)?.placeholder?.replace("*", "")}
          label={(
            <>
              Social Security Number&nbsp;
              <OverlayTrigger
                placement="top"
                delay={{ show: 0, hide: 0 }}
                trigger={["hover", "click"]}
                overlay={(
                  <Tooltip id={`tooltip-${FORM_FIELD_KEYS.deceasedSSN}-subhint`} className="subhintTooltipFederal">
                    <span>
                      In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                      This information is secured with SSL encryption.
                    </span>
                  </Tooltip>
                )}
              >
                <a className="ssn-subhint-title">
                  Why is this needed?
                </a>
              </OverlayTrigger>
            </>
          )}
          value={values[FORM_FIELD_KEYS.deceasedSSN]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default DeceasedIndividualInfoBlock;
